import Finance from "../../components/finance";
import Layout from "../../layout/main";
/**
 * FinancePages
 *
 * صفحه مالی که بخش مدیریت و نمایش اطلاعات مالی را ارائه می‌دهد.
 * این صفحه از Layout اصلی برای ساختار کلی اپلیکیشن استفاده می‌کند.
 *
 * ویژگی‌ها:
 * - استفاده از Layout برای یکپارچگی طراحی
 * - نمایش کامپوننت Finance که اطلاعات مالی، گزارش‌ها و امکانات مرتبط را ارائه می‌کند
 *
 * @returns JSX.Element
 */

const FinancePages = () => {
  return (
    <Layout>
      <Finance />
    </Layout>
  );
};

export default FinancePages;
